import { KIZEN_PREFIX, LocalStorage } from './Storage';

const THEME_KEY = `${KIZEN_PREFIX}theme`;

export const themeLocalStorage = new LocalStorage<string>(THEME_KEY);
